import { Grid } from "@material-ui/core";
import React, { useEffect, useContext } from "react";
import LoadingOverlay from 'react-loading-overlay';
import ReactLoading from 'react-loading';
import Button from "utils/CustomButtons/Button";
import PaginatedTable from "utils/Table/PaginatedTable";
import ExportButton from "utils/CustomButtons/ExportToCVSButton";
import { CallAPI } from "services/API";
import { DeviceContext } from 'utils/Device/DeviceContext';

export default function GWPPP_Detailed(props) {
    const device = useContext(DeviceContext);
    const isMobile = device.isMobile;
    const currency = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    });

    const [data, setData] = React.useState([]);
    const [loading, setLoading] = React.useState(false);
    const [isPP, setIsPP] = React.useState(false);

    const handleIsPP = () => {
        var toggle = !isPP;
        setIsPP(toggle);
        setLoading(true);
        GetData(toggle);
    };

    const GetData = async (isPP) => {
        const response = await CallAPI("POST", "/Advanced/GetTotalGrossWrittenOrPostedPremium", {
            startDate: props.startDate,
            endDate: props.endDate,
            states: props.states,
            city: props.city,
            groupBy: props.groupBy,
            isPP: isPP
        });

        if (response) {
            const formattedResponse = response.map((row) =>
                props.states?.length === 1 && props.states[0] === 'PA' ? [
                    row.groupBy,
                    currency.format(row.totalPrem),
                    currency.format(row.comp),
                    currency.format(row.coll),
                    currency.format(row.bi),
                    currency.format(row.umbi),
                    currency.format(row.uimbi),
                    currency.format(row.pd),
                    currency.format(row.rent),
                    currency.format(row.road),
                ] : [
                    row.groupBy,
                    currency.format(row.totalPrem),
                    currency.format(row.pip),
                    currency.format(row.comp),
                    currency.format(row.coll),
                    currency.format(row.bi),
                    currency.format(row.umbi),
                    currency.format(row.uimbi),
                    currency.format(row.pd),
                    currency.format(row.ppi),
                    currency.format(row.rent),
                    currency.format(row.road),
                ]
            );

            setData(formattedResponse);
        }

        setLoading(false);
    };

    useEffect(() => {
        if (props.call === "true" || props.call === null) {
            GetData(isPP);
            setLoading(true);
        }
    }, [props.call]);

    return (
        <Grid container>
            <Grid item lg={12} xs={12}>
                    <Grid container>
                        <Grid item
                            style={
                                isMobile ?
                                    {
                                        margin: "1em 0 1em 0",
                                        padding: "1.5em 1em 0.75em 1em",
                                        width: "100%",
                                        backgroundColor: "#f1f1f1",
                                        position: "relative",
                                        textAlign: "center",
                                        minWidth: "325px"
                                    }
                                    :
                                    {
                                        backgroundColor: "#f1f1f1",
                                        width: "100%",
                                        margin: "2em",
                                        padding: "3em 1.9em 1.5em 1.9em",
                                        position: "relative",
                                        textAlign: "center",
                                        minWidth: "325px"
                                    }
                            }
                        >
                            <span

                            >
                                <span
                                    style={{
                                        fontWeight: "bold",
                                        fontSize: isMobile ? "1.3em" : "2.5em",
                                        lineHeight: "1em",
                                        color: "#1d4c80"
                                    }}
                                >
                                {isPP ?
                                    "POSTED PREMIUM"
                                    :
                                    "GROSS WRITTEN PREMIUM"
                                }
                                </span>
                        </span>
                        <Button onClick={handleIsPP} style={{ color: 'white', margin: '20px', backgroundColor: '#ff8000' }} color="primary" size="md"> {isPP ? "TOGGLE GWP" : "TOGGLE PP"}</Button>
                        {!isMobile && <br />}
                        <br />
                        <span>
                            <span
                                style={{
                                    fontWeight: "bold",
                                    fontSize: isMobile ? "1.12em" : "1.75em",
                                    color: "#1d4c80"
                                }}
                            >
                                {isPP ?
                                    "Total Posted Premium"
                                    :
                                    "Total Gross Written Premium"
                                }
                            </span>
                        </span>
                        <LoadingOverlay
                            active={loading}
                            styles={{
                                overlay: (base) => ({
                                    ...base,
                                    position: "absolute!important"
                                })
                            }}
                            spinner={<ReactLoading type={'spin'} height={50} width={50} />}
                        >
                            <PaginatedTable
                                style={{
                                    Header: { minWidth: "120px", lineHeight: "1em", textAlign: "left" },
                                    Body: { textAlign: "left" },
                                    Footer: { textAlign: "left" }
                                }}
                                headers={[props.states?.length === 1 && props.states[0] === 'PA' ?
                                    [props.groupBy, "TOTAL PREM", "COMP", "COLL", "BI", "UMBI", "UIMBI", "PD", "RENT", "ROAD"] :
                                    [props.groupBy, "TOTAL PREM", "PIP", "COMP", "COLL", "BI", "UMBI", "UIMBI", "PD", "PPI", "RENT", "ROAD"]
                                ]}
                                fixedColumns={1}
                                rows={data.filter(x => x[0] !== "Total")}
                                footers={data.filter(x => x[0] === "Total")}
                            />
                        </LoadingOverlay>
                        <ExportButton
                            ExportName="Total_Gross_Written_Premium"
                        />
                        </Grid>
                    </Grid>
            </Grid>
        </Grid>
    );
}
